// extracted by mini-css-extract-plugin
export default {"section":"GridTabSection_section__kO5WM","separator":"GridTabSection_separator__Z88Qw"};